<dff-side [observable]="vm$">
  @if (vm$ | async; as vm) {
    <dff-side-titel>
      <button mat-icon-button type="button" class="button-back" (click)="navigerTilOversigt()" title="Tilbage">
        <mat-icon svgIcon="arrow-left"></mat-icon>
      </button>
      {{ vm.formGroup.get("navn").value }}</dff-side-titel
      >
      @if (udfoererOpgave) {
        <dff-upload-progress-overlay [value]="progress$ | async"></dff-upload-progress-overlay>
      }
      <form [formGroup]="vm.formGroup" autocomplete="off">
        @if (opgaveUdfoertMedSuccess) {
          <empty-page-badge svgIcon="check-circle-outline" overskrift="Opgaven er udført">
            <p>Du har udført opgaven med success</p>
            <button mat-flat-button type="button" color="primary" (click)="navigerTilInstallationer()">
              Tilbage til Installationer
            </button>
          </empty-page-badge>
        }
        @if (!opgaveUdfoertMedSuccess) {
          <div>
            @if (vm.maalerOplysninger?.installationNr !== nullInstallationNr) {
              <servicerapport-maaler-oplysninger
                [data]="vm.maalerOplysninger"
                >
              </servicerapport-maaler-oplysninger>
            }
            <div formArrayName="arbejdsgange">
              @for (arbejdsgangFormGroup of vm.formGroup.get('arbejdsgange').controls; track arbejdsgangFormGroup) {
                <div>
                  <arbejdsgang
                    [formGroup]="arbejdsgangFormGroup"
                    [komponentTyper]="vm.komponentTyper"
                    [ejendomsfaktorDefinitioner]="vm.ejendomsfaktorDefinitioner"
                    (opretKomponent)="onOpretKomponent($event)"
                    >
                  </arbejdsgang>
                </div>
              }
            </div>
            <dff-error-panel [error]="error"></dff-error-panel>
            <div class="button-panel">
              <button
                #udfoerKnap
                mat-flat-button
                type="button"
                color="primary"
                (click)="onUdfoerOpgaveClick(vm.formGroup)"
                [disabled]="udfoererOpgave || !vm.formGroup.valid"
                >
                @if (udfoererOpgave) {
                  <mat-spinner class="mat-spinner" diameter="25"></mat-spinner>
                }
                <span>Udfør opgave</span>
              </button>
            </div>
          </div>
        }
      </form>
    }
  </dff-side>
